import { Button, Popover } from 'antd'
import { History } from 'lucide-react'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useStyles } from 'src/components/chat'

import type { SquadChat } from '../useSquadChat'

import { ChatHistoryPanel } from './ChatHistoryPanel'

const ICON_SIZE = 15

type Props = {
  squad: SquadChat
  trigger?: ReactElement
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

export const ChatHistory = ({ squad, trigger, open, onOpenChange }: Props) => {
  const { styles } = useStyles()
  const { t } = useTranslation()
  const { conversations } = squad
  const historyOpen = open ?? squad.historyOpen

  const setHistoryOpen = (nextOpen: boolean) => {
    if (onOpenChange) {
      onOpenChange(nextOpen)

      return
    }
    if (nextOpen) squad.openHistory()
    else squad.closeHistory()
  }

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={historyOpen}
      onOpenChange={setHistoryOpen}
      styles={{ container: { padding: 0 } }}
      content={
        <div className={styles.historyPopoverPanel}>
          <ChatHistoryPanel
            conversations={conversations.conversations}
            activeId={conversations.activeId}
            onSelect={(id) => {
              conversations.selectConversation(id)
              setHistoryOpen(false)
            }}
            onDelete={(id) => conversations.deleteConversation(id)}
            onRename={(id, title) =>
              conversations.renameConversation(id, title)
            }
            search={conversations.search}
            onSearchChange={conversations.setSearch}
            loading={conversations.loadingList}
            loadingMore={conversations.loadingMoreList}
            hasMore={conversations.hasMoreConversations}
            onLoadMore={conversations.loadMoreConversations}
          />
        </div>
      }
    >
      {trigger ?? (
        <Button
          type="text"
          size="small"
          icon={<History size={ICON_SIZE} />}
          aria-label={t('workspaceHome.history.title')}
          className={styles.topBarButton}
        >
          {t('workspaceHome.history.title')}
        </Button>
      )}
    </Popover>
  )
}
